export const WorkOrganizationNameConstants = {
  MinimalLengthForRequest: 3,
};
